import { Component } from "react";
import { clearSessionLockCookies } from "../services/sessionLockService";

class Logout extends Component {
  componentDidMount() {
    clearSessionLockCookies();

    if (process.env.NODE_ENV === "production") {
      const logoutBaseUrl =
        process.env.REACT_APP_LOGOUT_URL ||
        "https://login.vicuscapital.com/logout.html";
      const returnUrl =
        process.env.REACT_APP_LOGOUT_RETURN_URL || window.location.origin;

      window.location = `${logoutBaseUrl}?from=${encodeURIComponent(returnUrl)}`;
    }
  }
  render() {
    return null;
  }
}

export default Logout;
